(() => {
  const roots = document.querySelectorAll('[data-tcg-pack-sim]');
  if (!roots.length) return;

  const CARD_BACK_LABEL = '⚡';

  function parseUrls(raw) {
    if (!raw) return [];
    try {
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed.filter((item) => typeof item === 'string' && item.length > 0);
    } catch {
      return [];
    }
  }

  function buildCard(url, index) {
    const card = document.createElement('button');
    card.type = 'button';
    card.className = 'tcg-pack-sim__card';
    card.setAttribute('aria-label', `Karte ${index + 1} umdrehen`);

    const inner = document.createElement('div');
    inner.className = 'tcg-pack-sim__card-inner';

    const back = document.createElement('div');
    back.className = 'tcg-pack-sim__face tcg-pack-sim__face--back';
    back.textContent = CARD_BACK_LABEL;

    const front = document.createElement('div');
    front.className = 'tcg-pack-sim__face tcg-pack-sim__face--front';

    if (url === 'placeholder') {
      const placeholder = document.createElement('div');
      placeholder.style.cssText =
        'display:grid;place-items:center;height:100%;color:#94a3b8;font-size:1.1rem;padding:0.4rem;text-align:center;';
      placeholder.textContent = 'Beispiel';
      front.appendChild(placeholder);
    } else {
      const img = document.createElement('img');
      img.src = url;
      img.alt = `Karten-Vorschau ${index + 1}`;
      img.loading = 'lazy';
      front.appendChild(img);
    }

    inner.append(back, front);
    card.append(inner);

    card.addEventListener('click', () => {
      card.classList.toggle('is-flipped');
    });

    return card;
  }

  roots.forEach((root) => {
    const trigger = root.querySelector('[data-pack-trigger]');
    const overlay = root.querySelector('[data-pack-overlay]');
    const deck = root.querySelector('[data-pack-deck]');
    const closeBtn = root.querySelector('[data-pack-close]');
    const revealAllBtn = root.querySelector('[data-pack-reveal-all]');
    const urls = parseUrls(root.dataset.previewUrls);
    const previewCount = Math.max(
      1,
      Number.parseInt(root.dataset.previewCount || '5', 10) || 5
    );

    if (!trigger || !overlay || !deck) return;

    if (root.dataset.previewCount) {
      overlay.dataset.previewCount = root.dataset.previewCount;
    }
    if (previewCount === 3) {
      overlay.classList.add('tcg-pack-sim__overlay--preview-3');
      overlay.querySelector('.tcg-pack-sim__dialog')?.setAttribute('data-preview-count', '3');
    }

    // Escape transformed product-info ancestors so the modal covers the full viewport.
    if (overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }

    const open = () => {
      deck.replaceChildren();
      const picks = urls.slice(0, previewCount);
      while (picks.length < previewCount) picks.push('placeholder');

      picks.forEach((url, index) => {
        deck.append(buildCard(url, index));
      });

      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
    };

    const close = () => {
      overlay.hidden = true;
      document.body.style.overflow = '';
    };

    trigger.addEventListener('click', open);
    closeBtn?.addEventListener('click', close);
    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) close();
    });
    revealAllBtn?.addEventListener('click', () => {
      deck.querySelectorAll('.tcg-pack-sim__card').forEach((card) => {
        card.classList.add('is-flipped');
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !overlay.hidden) close();
    });
  });
})();
